import { Component, OnInit } from '@angular/core';
import { TransportorsService } from 'src/app/services/transportors/transportors.service';

@Component({
  selector: 'app-societies-transportors',
  templateUrl: './societies-transportors.component.html',
  styleUrls: ['./societies-transportors.component.css']
})
export class SocietiesTransportorsComponent implements OnInit {

  allSocties:any = []

  constructor(private transServices: TransportorsService) { }

  ngOnInit(): void {
    this.allSocieties()
  }

  async allSocieties() {
    await this.transServices.allSocieties().then((res: any) => {
      if (res) {
        console.log("resssssssss : ")
        console.log(res)
        this.allSocties = res;
      }
    });
  }

}
